import React from "react";
import Grid from "housecall-ui/dist/DesignSystem/Layout/Grid/Grid";
import Typography from "housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography";
import ApiKeyManagementIcon from "housecall-ui/dist/IconsAndImages/AppIcons/ApiKeyManagementIcon";
import ApiKeyManagementUpgradeButtons from "../ApiKeysManagement/ApiKeyManagementUpgradeButtons";

const ApiKeysManagementStrategy = {
  previewInfo: {
    name: "API",
    iconSvg: <ApiKeyManagementIcon size="xlarge" />,
  },
  headerInfo: {
    name: "API",
    category: "Operations",
    details: (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: "bold" }}>What is an API?</Typography>
          <br/>
          <Typography paragraph>
            APIs are used to connect two apps together so that certain actions in one app 
            automatically trigger a response in another app. 
            Another way to think about APIs is that you don’t need to leave Housecall Pro to do 
            something in another app (or vice versa.)
            </Typography>
            <Typography paragraph>
            Building an integration using an open API typically requires hiring a software 
            developer or a third party company. 
          </Typography>
          <Typography paragraph>
            By using the Housecall Pro API, you can potentially expose sensitive data to a third party 
            or create new content in your Housecall Pro account. Some examples include:
            <ul>
              <li>Create customers or get customer information</li>
              <li>Create employees or get employee information</li>
              <li>Create jobs or get job information</li>
              <li>Create, get, or add attachments and links to jobs</li>
              <li>Receive events when jobs are created, scheduled, completed, and paid</li>
              <li>Receive events when estimates are created, scheduled, completed, and won</li>
              <li>Receive events when customers are created or updated</li>
            </ul>
          </Typography>
          <Typography paragraph>
            Once you’ve identified a trusted developer to build an integration, 
            you will need to grant them an API key and share our public API Documentation with them to get started.
          </Typography>
          <Typography paragraph>
          All of our public APIs are documented here: <a href="https://docs.housecallpro.com/"> https://docs.housecallpro.com/ </a>
          </Typography>
          <br/>
          <Typography style={{ fontWeight: "bold" }}>What is an API Key?</Typography>
          <br/>
          <Typography paragraph>
            An API key is a system-generated password that allows your developer to access your data. 
            You may generate or delete unique API keys at any time. If you delete an API key that is in use, 
            your integration will no longer work. It is highly recommended that you name your API keys to track who 
            you’ve shared your data with.
          </Typography>
        </Grid>
      </Grid>
    ),
    iconSvg: <ApiKeyManagementIcon size="xlarge" />,
  },
  sellingPoints: {},
  price: {
    hideToggle: true,
    hideCard: true,
    appActionButton: <ApiKeyManagementUpgradeButtons />
  },
};

export default ApiKeysManagementStrategy;
